<template>
  <div class="pushingSet">
    <el-form :model="pushingSetForm" :rules="pushingSetRules" class="pushingSetForm" ref="pushingForm">
      <el-form-item label="推送人群" prop="sendType" label-width="100px">
        <el-radio-group v-model="pushingSetForm.sendType" size="small" @change="sendTypeChange">
          <el-radio :label="1" >按条件选择</el-radio>
          <el-radio :label="2" >选择全部联系人</el-radio>
        </el-radio-group>

      </el-form-item>
      <el-form-item label="" label-width="100px">
        <!-- 推送人群搜索条件 -->
        <div v-show="pushingSetForm.sendType==1">
          <el-row class="rowItem" :gutter="10" >
            <el-col :span="8">
              <el-form-item label-width="60px" label="所属职务" >
                <el-select v-model="pushingSetForm.title" multiple 
                filterable :filter-method="titleDataFilter" placeholder="请选择"  collapse-tags clearable >
                  <el-option
                    v-for="item in titleIdArr" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-select 
                  v-model="pushingSetForm.title" 
                  placeholder="请选择"
                  multiple 
                  collapse-tags
                  filterable 
                  size="small" 
                  :remote="true" 
                  reserve-keyword  
                  :remote-method="searchAcceptorComp"
                  @change="acceptorCompChange"
                  @focus="acceptorCompFocus"
                  clearable
                  :loading="titleGroupIdsloading"
                  >
                  <el-option v-for="item in titleIdArr" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="60px" label="所属行业">
                <el-select v-model="pushingSetForm.industry" multiple 
                filterable :filter-method="IndustryDataFilter" placeholder="请选择"  collapse-tags clearable >
                  <el-option
                    v-for="item in saas_customer_industry" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-select 
                  v-model="pushingSetForm.industry" 
                  placeholder="请选择"
                  multiple 
                  collapse-tags
                  filterable 
                  size="small" 
                  :remote="true" 
                  reserve-keyword  
                  :remote-method="searchAcceptorindustry"
                  @change="acceptorCompChangeindustry"
                  @focus="acceptorIndustryFocus"
                  clearable
                  :loading="industryLoading"
                  >
                  <el-option v-for="item in saas_customer_industry" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="90px" label="所属国家/区域" >
                <el-select v-model="pushingSetForm.areas" placeholder="请选择" multiple 
                filterable :filter-method="countryIdDataFilter"
                collapse-tags 
                clearable >
                  <el-option
                  v-for="item in countryIdArr"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row class="rowItem" :gutter="10" >
            <el-col :span="8">
              <el-form-item label="客户等级" label-width="60px"  >
                <el-select v-model="pushingSetForm.level"   placeholder="请选择" multiple collapse-tags clearable >
                  <el-option
                    v-for="item in saas_supplier_customer_level"
                    :key="item.codeValue"
                    :label="item.name"
                    :value="item.codeValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="跟进状态" label-width="60px">
                <el-select v-model="pushingSetForm.followStatus" placeholder="请选择"  collapse-tags clearable >
                  <el-option
                  v-for="item in saas_supplier_customer_follow_status"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="Number(item.codeValue)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮箱发送记录" label-width="84px">
                <el-select v-model="pushingSetForm.unSendDateTime" placeholder="请选择"  collapse-tags clearable >
                  <el-option
                  v-for="item in edm_un_send_date"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="Number(item.codeValue)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row  class="rowItem" :gutter="10">
            <el-col :span="8">
              <el-form-item label="客户添加时间"  label-width="90px">
                <el-date-picker
                  v-model="pushingSetForm.addUserTime"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptionsarr"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
                <!-- <el-select v-model="pushingSetForm.addUserTime" placeholder="请选择"  collapse-tags clearable >
                  <el-option
                  v-for="item in edm_un_send_date"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="Number(item.codeValue)">
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <div class="searchBtn">
            <el-button @click="cancel">重置</el-button>
            <el-button type="primary" @click="search">搜索</el-button>
          </div>
          <!-- 按条件选择 -->
          <div class="sendTable">
            <span class="label">发送用户数:</span>
            <span class="num">{{totalNum}}</span>
            <span class="explain">说明:为了保障您的使用体验，已为您过滤:排除列表中的收件人。</span>
            <sendTable :tableData="tableData"/>
            <div class="pagetionStyle" v-if="tableData.length"> 
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="customerUserSearch.curPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="customerUserSearch.pageSize"
                layout="total, sizes,prev,pager,next, jumper"
                :total="totalNum"
                ref="pagina"
                >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- 全部联系人 -->
        <div v-if="pushingSetForm.sendType==2">
          <div class="tosendAll">
            <span class="sendLable">发送用户数:</span>
            <span class="sendnum">{{totalNumAll}}</span>
          </div>
          <div class="tosendAll">
            <span class="sendLable">说明:</span>
            <span class="sendExplain">为了保障您的使用体验，已为您过滤:排除列表中的收件人。</span>
          </div>
        </div>
      </el-form-item>
      <!-- 发件人邮箱 -->
      <el-form-item label="发件人邮箱" label-width="100px">
        <div>
          {{this.$store.state.supplierState.sendMail}}
        </div>
      </el-form-item>
      <!-- 回复邮箱 -->
      <el-form-item label="回复邮箱" label-width="100px" prop="replyEmail" class="replyEmail">
        <el-input placeholder="输入文字" v-model="pushingSetForm.replyEmail" size="small" @blur="pushingSetFormData('replyEmail')"></el-input>
      </el-form-item>
      <!-- 发送时间 -->
      <el-form-item label="发送时间" label-width="100px" prop="sendModel">
         <el-radio-group v-model="pushingSetForm.sendModel" size="small" @change="sendModelChange">
          <el-radio :label="1" >立即发送</el-radio>
          <el-radio :label="2" >定时发送</el-radio>
        </el-radio-group>
        <div v-if="false">

          <!-- 选择日期 -->
          <el-date-picker v-model="dates" align="right" type="date" :placeholder="'选择日期'"
            :picker-options="pickerOptions" size="mini" class="date" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @change="datesBlur">
          </el-date-picker>
          <!-- 选择时间 -->
          <el-time-picker v-model="time" :placeholder="'选择时间'" size="mini" class="date"
            format="HH:mm" value-format="HH:mm" :picker-options="pickerOptionsTime"
            :disabled="timeDefault" @blur="datesTime" @focus="pickerTime">
          </el-time-picker>
        </div>
        <div v-if="pushingSetForm.sendModel==2">
          <el-form :model="timezoneSetForm" :rules="timezoneSetRules" ref="timezoneSetForm" class="TimezoneSetForm">
            <el-form-item label="选择时区" label-width="100px" prop="scheduleSendTimezone" class="scheduleSendTimezone"> 
              <el-select v-model="timezoneSetForm.scheduleSendTimezone" 
              placeholder="请选择"  collapse-tags  @change="scheduleSendTimezoneChange" >
                <el-option
                v-for="item in timeDetail"
                :key="item.id"
                :label="item.label"
                :value="item.codeVal">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当地时间" label-width="100px" flexd prop="scheduleSendTimezoneTime" class="scheduleSendTimezoneTime"> 
              <!-- 选择日期 -->
              <el-date-picker v-model="dates" align="right" type="date" :placeholder="'选择日期'"
                size="mini" class="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" @change="datesBlur">
              </el-date-picker>
              <!-- 选择时间 -->
              <el-time-picker v-model="time" :placeholder="'选择时间'" size="mini" class="date datesTime"
                format="HH:mm" value-format="HH:mm" :picker-options="pickerOptionsTime"
                :disabled="timeDefault" @blur="datesTime" >
              </el-time-picker>
            </el-form-item>
            <div v-if="timezoneSetForm.scheduleSendTimezoneTime">邮件将在(UTC+8:00)北京、香港、台湾时间：<span class="localtime">{{timeresY}}</span> 发送</div>
          </el-form>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import sendTable from "@/components/intellect-marketing/mailDetail/sendTableList"
import { handleFormatDate, handleFormatDateHHmmss } from "@/utils/handle.js";
// import { getDictByType, } from '@/utils/api/common.js';
import {countryList} from "@/utils/api/seamark"
import timeDetail from "@/assets/js/timeDetail.js"
import { dayjsFormat } from '@/utils/common.js'
import {listUsers,findFilterConditions,userTitleByKeyword,industryByKeyword,listUserCountry} from "@/utils/api/edmSubject"
export default {
  components: {
    sendTable,
  },
  data(){
    var checkType = (rule, value, callback) => {
      if (this.pushingSetForm.sendType == 1) {
        if (this.totalNum == 0) {
          return callback(new Error('按条件-推送人群不能为0'));
        } else {
          callback();
        }
      } else if (this.pushingSetForm.sendType == 2) {
        if (this.totalNumAll == 0) {
          return callback(new Error('联系人-推送人群不能为0'));
        } else {
          callback();
        }
      }
    }
    // 邮箱校验
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-]+\.)+)([a-zA-Z]{2,10}|[0-9]{1,3})$/;
      if (value === "" || !value) {
        return callback(new Error('输入邮箱'));
      }
      else if (!reg.test(value)) {
        return callback(new Error('邮箱格式有误'));
      } else {
        callback();
      }
    };
    // 定时时间校验
    var checkTime = (rule, value, callback) => {
      if (this.pushingSetForm.sendModel == 2) {
        if (
          this.dates == "" ||
          this.time == "" ||
          this.dates == null ||
          this.time == null||this.pushingSetForm.scheduleSendTimezone==''
        ) {
          return callback(new Error('定时时间'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return{
      pickerOptionsarr: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      customerlevel:[],
      followstatus:[],
      followstatusitem:[],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptionsTime: {
        selectableRange: "00:00:00 - 23:59:59",
      },
      dates:'',//日期处理
      time:'',//时间处理
      timeDefault: true,//日期时间的校验
      pushingSetForm: {
        sendType:1,
        title:[],
        industry:[],
        areas:[],
        level:[],
        followStatus:'',
        unSendDateTime:'',
        replyEmail:'',
        sendModel:1,//发送模式 1=立即发送;2=定时发送
        scheduleSendTime:'',//定时发送的时间
        addUserTime:[],//客户添加时间
        scheduleSendTimezone:'Asia/Shanghai',//时区
        scheduleSendTimezoneTime:"",//定时时区的时间
      },
      pushingSetRules: {
        sendType:[
          { required: true,validator: checkType, trigger: "blur" }
        ],
        replyEmail:[
          { required: true, validator: checkEmail, trigger: "blur" },
        ],
        // sendModel: [{ required: false, validator: checkTime, trigger: "blur" }],
      },
      // 后台搜索用的条件
      filterConditionsMap:{
        areas:[],
        industry:[],
        title:[],
        level:[],
        followStatus:[],
        unSendDateTime:[],
        addUserTime:[]//客户添加时间
      },
      // 当前页面的搜索条件出来结果
      customerUserSearch:{
        curPage: 1,
        pageSize: 10,
        areas: [],
        industry: [],
        title: [],
        level:[],
        followStatus:[],
        unSendDateTime:[],
        addUserTime:[],//客户添加时间
      },
      totalNum:0,//按条件搜索结果总数据
      totalNumAll:0,//全部联系人总数据
      tableData:[],//搜索的结果
      sendTypeAllData:0,//全部联系人用户数量
      titleIdArr:[],//职位的数据结构
      titleIdArrCopy:[],//职位回显上下一步
      countryIdArr:[],//国家的数据结构
      saas_customer_industry:[],//行业数据类型
      saas_customer_industryCopy:[],//行业数据回显上下一步
      filterGroupArr:[],//按条件搜索
      industryChangeArr:[],
      areasChangeArr:[],
      titleChangeArr:[],
      levelChangeArr:[],
      followStatusChangeArr:[],
      unSendDateTimeChangeArr:[],
      titlekeyword:'',
      industryword:'',
      countryIdArrFilter:[],
      saas_supplier_customer_level:[],//客户等级
      saas_supplier_customer_follow_status:[],//跟进状态
      edm_un_send_date:[],//发送条件
      titleGroupIdsloading:false,
      industryLoading:false,
      timezoneSetForm: {
        scheduleSendTimezone:'Asia/Shanghai',//时区
        scheduleSendTimezoneTime:"",//定时的时间
      },
      timezoneSetRules: {
        scheduleSendTimezone: [{ required: true,  message: '请选择时区', trigger: 'change' }],
        scheduleSendTimezoneTime: [{ required: true, validator: checkTime, trigger: "blur" }],
      },
      // 时区处理
      dates:'',
      time:'',
      timeDetail:timeDetail,
      localtime:'',
      timeresY:'',
      scheduleSendTimezone:'',
    }
  },
  mounted(){
    this.getcountryList()
    this.findIndustryData()
    this.findTitleData()
    this.pushingSetForm.replyEmail=this.$store.state.supplierState.replyMail
  },
  methods:{
    // 上下一步数据回显处理
    paramsCopy(){
      this.titleIdArr=this.titleIdArrCopy
      this.saas_customer_industry=this.saas_customer_industryCopy
      this.pushingSetForm.areas=this.customerUserSearch.areas
      this.pushingSetForm.industry=this.customerUserSearch.industry
      this.pushingSetForm.title=this.customerUserSearch.title
      this.pushingSetForm.level=this.customerUserSearch.level
      this.pushingSetForm.addUserTime=this.customerUserSearch.addUserTime
      this.pushingSetForm.followStatus=''
      this.pushingSetForm.unSendDateTime=''
      this.customerUserSearch.followStatus.length==0?'':this.pushingSetForm.followStatus=this.customerUserSearch.followStatus[0]
      this.customerUserSearch.unSendDateTime.length==0?'':this.pushingSetForm.unSendDateTime=this.customerUserSearch.unSendDateTime[0]
    },
        // // 根据类型批量获取字典数据
    async getInitDictByType(codeMap){
      this.edm_un_send_date=codeMap.edm_un_send_date
      this.saas_supplier_customer_level=codeMap.saas_supplier_customer_level
      this.saas_supplier_customer_follow_status=codeMap.saas_supplier_customer_follow_status
    },
    // 获取数据
    pushingSetData(val){
      this.pushingSetForm.sendType=val.sendType
      this.pushingSetForm.title=val.searchForm.title!=null&&val.searchForm.title.length!=0?val.searchForm.title.map(Number):[]
      this.pushingSetForm.industry=val.searchForm.industry!=null&&val.searchForm.industry.length!=0?val.searchForm.industry.map(Number):[]
      this.pushingSetForm.areas=val.searchForm.areas!=null&&val.searchForm.areas.length!=0?val.searchForm.areas.map(Number):[]
      this.pushingSetForm.level=val.searchForm.level!=null&&val.searchForm.level.length!=0?val.searchForm.level.map(Number):[]
      this.pushingSetForm.addUserTime=val.searchForm.addUserTime!=null&&val.searchForm.addUserTime.length!=0?val.searchForm.addUserTime:[]
      this.pushingSetForm.followStatus=val.searchForm.followStatus!=null&&val.searchForm.followStatus.length!=0?Number(val.searchForm.followStatus[0]):''
      this.pushingSetForm.unSendDateTime=val.searchForm.unSendDateTime!=null&&val.searchForm.unSendDateTime.length!=0?Number(val.searchForm.unSendDateTime[0]):''
      this.pushingSetForm.replyEmail=val.replyEmail
      this.pushingSetForm.sendModel=val.sendModel
      this.pushingSetForm.scheduleSendTime=val.scheduleSendTime
      // this.titleIdArr=val.titleList
      // this.saas_customer_industry=val.industryList
      if(val.sendType==1&&(val.searchForm.areas.length!=0||val.searchForm.industry.length!=0||
      val.searchForm.title.length!=0||val.searchForm.level.length!=0||
      val.searchForm.followStatus.length!=0||val.searchForm.unSendDateTime.length!=0||val.searchForm.addUserTime.length!=0)){
        this.search()
      }
      if(val.sendType==2){
        this.search()
      }

      this.timezoneSetForm.scheduleSendTimezone=val.scheduleSendTimezone||'Asia/Shanghai'
      this.pushingSetForm.scheduleSendTimezone=this.timezoneSetForm.scheduleSendTimezone
      this.pushingSetForm.scheduleSendTimezoneTime=val.scheduleSendTimezoneTime||val.scheduleSendTime
      this.localtime=this.pushingSetForm.scheduleSendTimezoneTime||val.scheduleSendTime
      this.pushingSetForm.scheduleSendTime=val.scheduleSendTime
      if(this.pushingSetForm.sendModel==2&&this.pushingSetForm.scheduleSendTimezoneTime!=null&&this.pushingSetForm.scheduleSendTimezoneTime!=''){
        this.dates=handleFormatDate(this.pushingSetForm.scheduleSendTimezoneTime)
        this.time = handleFormatDateHHmmss(this.pushingSetForm.scheduleSendTimezoneTime);
        this.timeDefault = false;
      }
      console.log(this.pushingSetForm)
      this.sendModelChange()
      if(this.pushingSetForm.sendModel==2&&this.pushingSetForm.scheduleSendTimezoneTime!=null&&this.pushingSetForm.scheduleSendTimezoneTime!=''){
        this.localtimeBlur(true)
      }
    },

    // 重置
    cancel(){
      this.pushingSetForm.title=[]
      this.pushingSetForm.industry=[]
      this.pushingSetForm.areas=[]
      this.pushingSetForm.level=[]
      this.pushingSetForm.followStatus=''
      this.pushingSetForm.unSendDateTime=''
      this.pushingSetForm.addUserTime=[]
      this.tableData=[]
      this.totalNum=0
      this.customerUserSearch.curPage=1
      this.customerUserSearch.pageSize=10
      this.customerUserSearch.title=[]
      this.customerUserSearch.industry=[]
      this.customerUserSearch.areas=[]
      this.customerUserSearch.level=[]
      this.customerUserSearch.followStatus=[]
      this.customerUserSearch.unSendDateTime=[]
      this.customerUserSearch.addUserTime=[]
      this.pushingSetFormData('customerUserSearch')
      this.filterConditionsMap.areas=this.customerUserSearch.areas
      this.filterConditionsMap.industry=this.customerUserSearch.industry
      this.filterConditionsMap.title=this.customerUserSearch.title
      this.filterConditionsMap.level=this.customerUserSearch.level
      this.filterConditionsMap.followStatus=this.customerUserSearch.followStatus
      this.filterConditionsMap.unSendDateTime=this.customerUserSearch.unSendDateTime
      this.filterConditionsMap.addUserTime=this.customerUserSearch.addUserTime
      this.pushingSetFormData('filterConditionsMap')
      this.pushingSetFormData('submitTotal')
      this.filterGroupArr=[]
      this.pushingSetFormData('filterGroupArr')
    },
    // 搜索
    search(){
      this.customerUserSearch.areas=[]
      this.customerUserSearch.industry=[]
      this.customerUserSearch.title=[]
      this.customerUserSearch.level=[]
      this.customerUserSearch.followStatus=[]
      this.customerUserSearch.unSendDateTime=[]
      this.customerUserSearch.addUserTime=[]
      this.customerUserSearch.areas=this.pushingSetForm.areas
      this.customerUserSearch.industry=this.pushingSetForm.industry
      this.customerUserSearch.title=this.pushingSetForm.title
      this.customerUserSearch.level=this.pushingSetForm.level
      this.pushingSetForm.followStatus==''?[]:this.customerUserSearch.followStatus.push(this.pushingSetForm.followStatus)
      this.pushingSetForm.unSendDateTime==''?[]:this.customerUserSearch.unSendDateTime.push(this.pushingSetForm.unSendDateTime)
      this.customerUserSearch.addUserTime=this.pushingSetForm.addUserTime
      this.customerUserSearch.curPage=1
      this.customerUserSearch.pageSize=10
      this.getSearchData()
    },
    // 定时发送时的日期
    datesBlur () {
      this.timeDefault = false;
      // this.$emit("scheduleDates", this.dates);
      this.time = "";
      // if(this.time != ""&&this.dates!=''){
      //   let tempTime = this.dates + " " + this.time;
      //   console.log(tempTime)
      //   let date = new Date(tempTime);
      //   this.pushingSetForm.scheduleSendTime=date.getTime();
      //   this.pushingSetFormData('sendModel')
      // }
    },
    // 定时发送时的日期时间
    datesTime () {
      // if(this.time != ""&&this.dates!=''){
      //   let tempTime = this.dates + " " + this.time;
      //   let date = new Date(tempTime);
      //   this.pushingSetForm.scheduleSendTime=date.getTime();
      //   this.pushingSetFormData('sendModel')
      // }
      if(this.time != ""&&this.dates!=''){
        console.log(134123443)
        let tempTime = this.dates + " " + this.time;
        let date = new Date(tempTime);
        this.localtime=date.getTime();
        this.localtimeBlur()
        // this.contentSetForm.scheduleSendTime=date.getTime();
        // this.contentSetFormData('sendModel')
      }
    },
    // 限制时间
    pickerTime () {
      // 先判断日期是否为同一天
      var typeDates1 = handleFormatDate(new Date().getTime());
      var typeDates2 = handleFormatDateHHmmss(new Date().getTime());
      if (typeDates1 == this.dates) {
        this.pickerOptionsTime.selectableRange = typeDates2 + " - 23:59:59";
      } else {
        this.pickerOptionsTime.selectableRange = "00:00:00 - 23:59:59";
      }
    },
    // 时区
    scheduleSendTimezoneChange(){
      this.localtime=''
      this.time=''
      this.dates=''
      this.timeresY=''
      this.timezoneSetForm.scheduleSendTimezoneTime=''
      this.pushingSetForm.scheduleSendTimezone=this.timezoneSetForm.scheduleSendTimezone
    },
    localtimeBlur(flag){
      if(this.pushingSetForm.scheduleSendTimezone){
        let dayObj= dayjsFormat(this.localtime,this.pushingSetForm.scheduleSendTimezone)
        this.timeresY=dayObj.timeresY
        if(dayObj.sendtimestamp>dayObj.localTimeTamp){
          this.timezoneSetForm.scheduleSendTimezoneTime=this.localtime
          this.pushingSetForm.scheduleSendTime=dayObj.sendtimestamp
          this.pushingSetForm.scheduleSendTimezoneTime= this.timezoneSetForm.scheduleSendTimezoneTime
          
          this.pushingSetFormData('sendModel')
        }else{
          this.time=''
          this.dates=''
          this.timezoneSetForm.scheduleSendTimezoneTime=''
          this.pushingSetForm.scheduleSendTimezoneTime= this.timezoneSetForm.scheduleSendTimezoneTime
          if(!flag){
            this.$message.error('发送时间不能小于当前系统时间')
          }
        }
        
      }
    },
    // 获取国家
    async getcountryList(){
      let params={
        keyword:''
      }
      const res =await listUserCountry(params)
      this.countryIdArr=res.rspListData.list
      this.countryIdArrFilter=res.rspListData.list
    },
    // 条件处理
    sendTypeChange(){
      this.pushingSetFormData('sendType')
      if(this.pushingSetForm.sendType==1){
        this.totalNumAll=0
        this.tableData=[]
      }else{
        this.pushingSetForm.title=[]
        this.pushingSetForm.industry=[]
        this.pushingSetForm.areas=[]
        this.pushingSetForm.level=[]
        this.pushingSetForm.followStatus=''
        this.pushingSetForm.unSendDateTime=''
        this.pushingSetForm.addUserTime=[]
        this.tableData=[]
        this.totalNum=0
        this.customerUserSearch.curPage=1
        this.customerUserSearch.pageSize=10
        this.customerUserSearch.title=[]
        this.customerUserSearch.industry=[]
        this.customerUserSearch.areas=[]
        this.customerUserSearch.level=[]
        this.customerUserSearch.followStatus=[]
        this.customerUserSearch.unSendDateTime=[]
        this.customerUserSearch.addUserTime=[]
        this.getSearchData()
      }
    },
    // 搜索结果翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.customerUserSearch.pageSize=val
      this.handleCurrentChange(1)
    },
    // 当前页
    handleCurrentChange(val) {
      this.customerUserSearch.curPage=val
      this.getSearchData()
    },
    // 条件搜索
    async getSearchData(){
      const res= await listUsers(this.customerUserSearch)
      if(this.pushingSetForm.sendType==1){
        this.totalNum=res.rspPageData.totalNum
        this.titleChangeArr=[]
        this.areasChangeArr=[]
        this.industryChangeArr=[]
        this.levelChangeArr=[]
        this.followStatusChangeArr=[]
        this.unSendDateTimeChangeArr=[]
        // 职位label处理
        this.customerUserSearch.title.map(item=>{
          this.titleIdArr.map((tmep,index)=>{
            if(item==tmep.id){
              this.titleChangeArr.push(tmep.name)
            }
          })
        })
        // 地区label处理
        this.customerUserSearch.areas.map(item=>{
          this.countryIdArr.map(tmep=>{
            if(item==tmep.codeValue){
              this.areasChangeArr.push(tmep.name)
            }
          })
        })
        // 行业label处理
        this.customerUserSearch.industry.map(item=>{
          this.saas_customer_industry.map(tmep=>{
            if(item==tmep.id){
              this.industryChangeArr.push(tmep.name)
            }
          })
        })
        // 客户等级label处理
        this.customerUserSearch.level.map(item=>{
          this.saas_supplier_customer_level.map(tmep=>{
            if(item==tmep.codeValue){
              this.levelChangeArr.push(tmep.name)
            }
          })
        })
        // 跟进状态label处理
        this.customerUserSearch.followStatus.map(item=>{
          this.saas_supplier_customer_follow_status.map(tmep=>{
            if(item==tmep.codeValue){
              this.followStatusChangeArr.push(tmep.name)
            }
          })
        })
        // 邮箱发送记录label处理
        this.customerUserSearch.unSendDateTime.map(item=>{
          this.edm_un_send_date.map(tmep=>{
            if(item==tmep.codeValue){
              this.unSendDateTimeChangeArr.push(tmep.name)
            }
          })
        })
        // 客户添加时间
        let itemfilterGroupArr=[
          {key:'所属地区',val:this.areasChangeArr.join()},//所属地区
          {key:'所属行业',val:this.industryChangeArr.join()},//所属行业
          {key:'所属职务',val:this.titleChangeArr.join()},//所属职务
          {key:'客户等级',val:this.levelChangeArr.join()},//客户等级
          {key:'跟进状态',val:this.followStatusChangeArr.join()},//跟进状态
          {key:'邮箱发送记录',val:this.unSendDateTimeChangeArr.join()},//邮箱发送记录
          {key:'客户添加时间',val:this.customerUserSearch.addUserTime.join()}//邮箱发送记录
        ]//按条件搜索
        this.filterGroupArr=itemfilterGroupArr
        this.pushingSetFormData('filterGroupArr')
      }else{
        this.filterGroupArr=[]
        this.totalNumAll=res.rspPageData.totalNum
        this.pushingSetFormData('filterGroupArr')
      }
      this.tableData=res.rspPageData.list
      this.pushingSetFormData('customerUserSearch')
      this.filterConditionsMap.areas=this.customerUserSearch.areas
      this.filterConditionsMap.industry=this.customerUserSearch.industry
      this.filterConditionsMap.title=this.customerUserSearch.title
      this.filterConditionsMap.level=this.customerUserSearch.level
      this.filterConditionsMap.followStatus=this.customerUserSearch.followStatus
      this.filterConditionsMap.unSendDateTime=this.customerUserSearch.unSendDateTime
      this.filterConditionsMap.addUserTime=this.customerUserSearch.addUserTime
      this.pushingSetFormData('filterConditionsMap')
      this.pushingSetFormData('submitTotal')
      // 单独校验一次
      this.$refs["pushingForm"].validateField('sendType');
    },
    // 发送时间
    sendModelChange(){
      console.log(this.pushingSetForm.sendModel)
      if (this.pushingSetForm.sendModel == "1") {
        this.$refs.pushingForm.fields.forEach(function (e) {
          if (e.prop === "sendModel") {
            e.resetField();
          }
        });
        this.dates = "";
        this.time = "";
        this.pushingSetForm.scheduleSendTime=''
        this.pushingSetForm.scheduleSendTimezoneTime=''
      }
      this.pushingSetFormData('sendModel')
    },
    // 表单验证
    pushingForm() {
      // return this.$refs["ruleForm"].validate().catch((err) => {});
      return new Promise((resolve, reject) => {
        this.$refs["pushingForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        });
      })
    },
    // 定时时区表单验证
    timezoneForm(){
      let a= new Promise((resolve, reject) => {
        this.$refs["timezoneSetForm"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        });
      })
      console.log(a)
      return a
    },
    // 传参处理
    pushingSetFormData(property){
      if(property=='sendType'){//推送人群
        this.$emit('pushingSetFormData',property,this.pushingSetForm[property])
      }else if(property=='sendModel'){//发送时间
        // this.$emit('pushingSetFormData',property,this.pushingSetForm[property])
        // this.$emit('pushingSetFormData','scheduleSendTime',this.pushingSetForm.scheduleSendTime)
        this.$emit('pushingSetFormData',property,this.pushingSetForm[property])
        this.$emit('pushingSetFormData','scheduleSendTimezone',this.pushingSetForm.scheduleSendTimezone)
        this.$emit('pushingSetFormData','scheduleSendTimezoneTime',this.pushingSetForm.scheduleSendTimezoneTime)
        this.$emit('pushingSetFormData','scheduleSendTime',this.pushingSetForm.scheduleSendTime)
        console.log(this.pushingSetForm)
      }else if(property=='replyEmail'){//回复邮箱
        this.$emit('pushingSetFormData',property,this.pushingSetForm[property])
      }else if(property=='submitTotal'){
        const submitTotal=this.pushingSetForm.sendType==1?this.totalNum:this.totalNumAll
        this.$emit('pushingSetFormData',property,submitTotal)
      }else if(property=='filterGroupArr'){
        this.$emit('pushingSetFormData',property,this.filterGroupArr)
      }else{//其他类
        this.$emit('pushingSetFormData',property,this[property])
      }
    },
    // 职位联想搜索
    // acceptorCompChange(event){
    //   console.log(event)
    //   // this.titleIdArr=[]
    //   // this.pushingSetForm.title=[]
    //   // this.findData(val)
    // },
    // acceptorCompFocus(){
    //   if(!this.titlekeyword){
    //     this.titleIdArr=[]
    //   }
    //   if(this.pushingSetForm.title.length==0){
    //     this.titlekeyword=''
    //     this.titleIdArr=[]
    //   }
    // },
    // searchAcceptorComp(query){
    //   console.log(query)
    //   let keyword = query.trim()
    //   if (keyword) {
    //     this.loading = true;
    //     // this.options = [];
    //     // this.curPage = 1;
    //     this.titlekeyword = keyword;
    //     this.findData(keyword);
    //   }
    // },
    findTitleData(){
      this.titleGroupIdsloading=true
      const params = {
        keyword: '',
      };
      this.titleIdArr=[]
      userTitleByKeyword(params).then(res=>{
        if(res.rspResult.bizCode==200){
          this.titleIdArr= res.rspListData.list
          this.titleIdArrCopy=JSON.parse(JSON.stringify(this.titleIdArr))
          // res.rspListData.list.forEach((row) => {
          //   this.titleIdArr.push(row);
          // });
          // console.log(this.pushingSetForm.title)
          // if (res.rspListData.list[0]) {
          //   // this.pushingSetForm.title = res.data.rspPageData.list[0].id;
          // }
          // this.titleIdArr=res.rspListData.list
        }
      })
      this.titleGroupIdsloading=false
    },
    titleDataFilter(val){
      if(val.trim().length>=2){
        // console.log(val)
        this.titleIdArr=this.titleIdArrCopy.filter(item=>{
          let reflag=true
          let valLen=val.trim().length
         loop: if(!item.name.toUpperCase().includes(val.trim().toUpperCase())){
            reflag=false
            break  loop
          }else{
            return item
          }
          return reflag
        })
      }else{
        this.titleIdArr=this.titleIdArrCopy
      }
    },

    // 所属行业联想搜索
    // searchAcceptorindustry(query){
    //   let keyword = query.trim()
    //   if (keyword) {
    //     // this.loading = true;
    //     // this.options = [];
    //     // this.curPage = 1;
    //     this.industryword = keyword;
    //     this.findIndustryData(keyword);
    //   }
    // },
    // acceptorIndustryFocus(){
    //   if(!this.industryword){
    //     this.saas_customer_industry=[]
    //   }
    //   if(this.pushingSetForm.industry.length==0){
    //     this.industryword=''
    //     this.saas_customer_industry=[]
    //   }
    // },
    findIndustryData(){
      this.industryLoading=true
      const params = {
        keyword: '',
      };
      this.saas_customer_industry=[]
      industryByKeyword(params).then(res=>{
        if(res.rspResult.bizCode==200){
          this.saas_customer_industry=res.rspListData.list
          this.saas_customer_industryCopy=JSON.parse(JSON.stringify(this.saas_customer_industry))
          // res.rspListData.list.forEach((row) => {
          //   this.saas_customer_industry.push(row);
          // });
        }
      })
      this.industryLoading=false
    },
    IndustryDataFilter(val){
      if(val.trim().length>=2){
        this.saas_customer_industry=this.saas_customer_industryCopy.filter(item=>{
          let reflag=true
          let valLen=val.trim().length
         loop: if(!item.name.toUpperCase().includes(val.trim().toUpperCase())){
            reflag=false
            break  loop
          }else{
            return item
          }
          return reflag
        })
      }else{
        this.saas_customer_industry=this.saas_customer_industryCopy
      }
    },
    // acceptorCompChangeindustry(){
    //   console.log(this.pushingSetForm.industry)
    // },
    // 国家区域联想搜索
    countryIdDataFilter(val){
      if(val.trim().length>=2){
        this.countryIdArr=this.countryIdArrFilter.filter(item=>{
          let reflag=true
          let valLen=val.trim().length
         loop: if(!item.name.toUpperCase().includes(val.trim().toUpperCase())){
            reflag=false
            break  loop
          }else{
            return item
          }
          return reflag
        })
      }else{
        this.countryIdArr=this.countryIdArrFilter
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.pushingSet{
  margin-top: 16px;
 ::v-deep .pushingSetForm{
    .el-form-item__label{
      color: #4f5d78ff;
      font-size: 12px;
      font-face: SourceHanSansCN;
      font-weight: 400;
    }
    .el-radio__label{
      font-size: 12px;
    }
    .el-checkbox__label{
      font-size: 12px;
    }
    .el-input--small .el-input__inner{
      // width: 220px;
      font-size: 12px;
    }
    .sys-note-index{
      width: 640px;
    }
    .el-select{
      width: 100%;
    }
  }
}
.pushingSet{
  margin-top: 24px;
}
::v-deep .rowItem{
  // margin-top: 24px;
  padding-right: 150px;
  .el-form-item__label{
    text-align: left;
  }
  .el-form-item .el-form-item{
    margin-bottom: 20px;
  }
  .el-input--small .el-input__inner{
    // width: 100% !important;
    // width: 640px;
  }

}
::v-deep .replyEmail{
  width: 540px;
  }
.searchBtn{
  text-align: right;
  margin-right: 150px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EDF0F4;
}
.sendTable{
  margin-right: 112px;
  margin-top: 20px;
  .label{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #4F5D78;
    margin-right: 8px;
  }
  .num{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #E6A23C;
    margin-right: 16px;
  }
  .explain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #16181A;
  }
}
.tosendAll{
  .sendLable{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #4F5D78;
    margin-right:8px ;
  }
  .sendnum{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #E6A23C;
  }
  .sendExplain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #16181A;
  }
}
.pagetionStyle{
  text-align: center;
  margin-top: 30px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    .el-input--small .el-input__inner{
      width: 50px !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
::v-deep .TimezoneSetForm{
  background: #F5F7FA;
  padding: 20px;
  width: 596px;
  .localtime{
    color:#066EB7 ;
  }
  .el-form-item__label:before{
    position: inherit !important;

  }
  .el-select {
      width: auto !important; 
  }
  .el-form-item__label{
    text-align: left;
  }
  .scheduleSendTimezone{
      width: 300px !important;
      .el-input__inner{
        width: 300px !important;
      }
    }
  .scheduleSendTimezoneTime{

    .date{
      width:176px !important;
      margin-right: 4px;
      .el-input__inner{
        width: 176px !important;
        padding-left: 30px !important;
      }
    }
    .datesTime {
      width: 120px !important;
      .el-input__inner{
        width: 120px !important;
      }
    }
  }
}

</style>